export const ROUTE_NAVIGATION_END_EVENT = 'routeNavigationEnd';
export const ROUTE_NAVIGATION_END_START = 'routeNavigationStart';